import {FeedbackInput} from '@adv-mt/frontend-ma--lib-trust'

import {ROUTES} from '../../config/index.js'
import {URL_PARAMS} from './config.js'

export const getInitialProps = async ({routeInfo, context}) => {
  const {pageName} = await context.domain
    .get('get_page_name_page_use_case')
    .execute({path: routeInfo.location.pathname})

  const adId = routeInfo.location.query[URL_PARAMS.AD_ID]
  const tradeId = routeInfo.params[URL_PARAMS.TRADE_ID]
  const token = routeInfo.location.query[URL_PARAMS.TOKEN]

  const TRUST_API_PATH = context.domain.get('config').get('TRUST_API_PATH')
  const API_URL = context.domain.get('config').get('API_URL')

  const feedbackInput = new FeedbackInput({
    appName: context.domain.get('config').get('APP_NAME'),
    baseUrl: `${API_URL}${TRUST_API_PATH}`,
    userToken: token
  })

  let feedbackOnItem

  try {
    feedbackOnItem = await feedbackInput.getFeedbackOnItem()
  } catch {
    return {
      __HTTP__: {
        redirectTo: ROUTES.ADS_LIST_SEARCH
      }
    }
  }

  return {
    adId,
    feedbackOnItem,
    pageName,
    token,
    tradeId
  }
}
